import { createContext } from "react";
const TabsContext = createContext({
    value: undefined,
    lazyRender: true,
    animated: false,
    swipeable: false,
    swipeThreshold: 5,
    tabObjects: [],
});
export default TabsContext;
